<template>
    <div>
        <Modal v-if="visible" :modelValue="visible"
               contentWidth="800px"
               :visible="visible" :title="'新增用户'" :showFooter="false" :overlayOpacity="0.5" @update:visible="visible = $event">
            <form :form="form">
                <div class="formDiv">
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="资产名称" type="text" id="name" :modelValue="form.name"
                                required placeholder="资产名称"
                                @update:modelValue="(value) => handleModelValueUpdate('name', value)"/>
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="品牌" type="text" id="brand" :modelValue="form.brand"
                                placeholder="品牌"
                                @update:modelValue="(value) => handleModelValueUpdate('brand', value)"/>
                </div>
                <div class="formDiv">
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="规格型号" type="text" id="specification"
                                :modelValue="form.specification" placeholder="规格型号"
                                @update:modelValue="(value) => handleModelValueUpdate('specification', value)"/>
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="单位" type="text" id="unit"
                                :modelValue="form.unit" placeholder="单位"
                                @update:modelValue="(value) => handleModelValueUpdate('unit', value)"/>
                </div>
                <div class="formDiv">
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="单价(元)" type="text" id="price"
                                :modelValue="form.price" required placeholder="单价(元)"
                                @update:modelValue="(value) => handleModelValueUpdate('price', value)"/>
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:45%" label="数量" type="number" id="number"
                                :modelValue="form.number" placeholder="数量"
                                @update:modelValue="(value) => handleModelValueUpdate('number', value)"/>
                </div>
                <div class="formDiv">
                    <SelectField labelWidth="40%" label="保管员" style="margin: 0.5rem 0.2rem;width:45%" id="chargerId"
                                 :modelValue="form.chargerId" :options="userList" required
                                 @update:modelValue="(value) => handleModelValueUpdate('chargerId', value)"/>
                </div>
                <div class="formButton">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { add } from "../api/list";
import Modal from '@/components/water-affairs-style/modal.vue';
export default {
  data() {
    return {
      form: {
          name:null,
          brand:null,
          specification:null,
          unit:null,
          price:null,
          number:null,
          chargerId:null
      },
      loading: false,
      visible:true,
    };
  },
  pops:{
    visible: {
        type: Boolean,
        default: true
    },
  },
  components: {
      Modal
  },
  computed: {
    ...mapState("userSelector", ["userList"]),
  },
  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.form.name) {
            this.$message.error('任务名称不能为空');
            this.isSubmitting = false; // 重置标志
            return;
        }
        if (!this.form.price) {
            this.$message.error('单价不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.chargerId) {
            this.$message.error('保管员不能为空');
            this.isSubmitting = false;
            return;
        }

          this.loading = true;
          add({
            ...this.form,
            charger: this.userList.find((item) => item.id === this.form.chargerId)
              .name,
          })
            .then(() => {
              this.cancel();
            })
            .finally(() => {
                this.isSubmitting = false;
            });
    },

    cancel() {
       this.visible = false;
    },
  },
};
</script>
<style scoped>
 .formDiv{
     display: flex;
     justify-content: space-between;
 }
 .formButton{
     margin-top: 1rem;
     width:100%;
     text-align: center;
 }
</style>
